import { connect } from 'react-redux'
import _ from 'lodash'
import { Icon } from '@vzmi/shp_shared_compo'
import styles from './SubHeader.css'
import { EMPTY_VALUE } from '../../../constants/globalTypes'

export const SubHeaderOffset = () => {
  return (
    <div className={styles.subHeader} />
  )
}

const SubHeader = (props) => {
  const { page } = props
  const sellerName = _.get(page, 'user.sellerName', EMPTY_VALUE)
  return (
    <div className={styles.subHeader}>
      <Icon
        name='groups-fill'
        size={50}
        color='#2b1f9e'
      />
      <span className={styles.subHeaderText}>
        <span className={styles.subHeaderTextTitle}>
          商店經營儀表板
        </span>
        <br />
        <span className={styles.subHeaderTextSubTitle}>
          {sellerName}
        </span>
      </span>
    </div>
  )
}

const mapStateToProps = (state, ownProps) => {
  return {
    page: state.page
  }
}

export default connect(
  mapStateToProps
)(SubHeader)
